module.exports = __webpack_public_path__ + "img/btn_google_light_focus_ios.32e3512e.svg";